/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Grid, Button } from '@mui/material'
import { Replay } from '@mui/icons-material'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import * as organization from '../../../appRedux/actions/fuel_request/organization'
import IntlMessages from '../../../util/IntlMessages'
import Comeback from '../../../components/comeback'
import useStyles from './styles'

function FuelRequestOrganizationInprocess(props) {
    const classes = useStyles()
    let { id } = useParams()
    let vRequestCode = id.replace(':id', '')

    const requestDetailsFunc = () => {
        props.fuelRequestOrganizationByRequestCodeAction(vRequestCode)
    }

    return (
        <Grid container>
            <Grid item xs={6} md={6}>
                <Comeback title={<IntlMessages id="requestOrganization" />} />
            </Grid>
            <Grid item xs={6} md={6} className={classes.gridReplay}>
                <Button startIcon={<Replay />} onClick={() => requestDetailsFunc()}>
                    {<IntlMessages id="refresh" />}
                </Button>
            </Grid>
        </Grid>
    )
}

const mapStateToProps = (state) => {
    return {
        list: state.field.list,
        loadingPage: state.common.loadingPage
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fuelRequestOrganizationByRequestCodeAction: (code) => dispatch(organization.fuelRequestOrganizationByRequestCodeAction(code)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FuelRequestOrganizationInprocess)
